<template>
	<b-modal
		ref="modal"
		no-close-on-backdrop
		centered
		hide-footer
		:title="pricing.id ? 'Edit pricing' : 'New pricing'"
		:modal-class="theme"
	>
		<PricingEdit
			:pricing="pricing"
			:error="errorMsg"
			:loading="loading"
			v-on:request-save="onRequestSave"
			v-on:close="hide"
		/>
	</b-modal>
</template>

<script>
import PricingEdit from "./PricingEdit";
import PricingService from "../../services/pricing";
import ThemeService from "../../services/theme";

export default {
	name: "PricingEditDialog",
	components: {
		PricingEdit,
	},
	data: function () {
		return {
			pricing: {},
			errorMsg: null,
			loading: false,
			theme: "light",
		};
	},
	created() {
		this.theme = ThemeService.instance().getTheme() || 'light';
		this.listenForThemeChanges();
	},
	methods: {
		show: function (pricing) {
			this.pricing = pricing;
			this.$refs.modal.show();
		},
		hide: function () {
			this.errorMsg = null;
			this.$refs.modal.hide();
		},
		onRequestSave: function (pricing) {
			this.loading = true;
			PricingService.instance()
				.editPricing(pricing)
				.then(() => {
					this.loading = false;
					this.$emit("save-success");
					this.hide();
				})
				.catch((error) => {
					this.loading = false;
					this.errorMsg = error;
				});
		},
		listenForThemeChanges: function () {
			ThemeService.instance().events.on("themechanged", () => {
				this.theme = ThemeService.instance().getTheme();
			});
		},
	},
};
</script>

<style>
</style>